import React from "react";
import { z } from "zod";
import { pluralizeWithCount } from "@common/helpers/string";
import { EntityChangeWarningsSchema } from "@common/schemas/domains/financialAccount/financial-account.schema";

export type EntityChangeWarnings = z.infer<typeof EntityChangeWarningsSchema>;

export const EntityChangeWarningMessage: React.FC<
    Readonly<{
        warnings: EntityChangeWarnings | null;
        error?: string | null;
    }>
> = ({ warnings, error }) => {
    if (error) {
        return (
            <div>
                <p>{error}</p>
            </div>
        );
    }

    if (!warnings) {
        return null;
    }

    if (warnings.transferError) {
        return (
            <div>
                <p>{warnings.transferError}</p>
            </div>
        );
    }

    const messages: string[] = [];
    if (warnings.hasDocumentsToTransfer) {
        messages.push(
            `${pluralizeWithCount("document", warnings.documentsCount)} linked to this account will be moved to the new entity`,
        );
    }
    if (warnings.hasJournalEntriesToTransfer) {
        messages.push(
            "Opening balances and manual journal entries will be transferred to the new entity",
        );
    }

    return (
        <div>
            <p>The following changes will be made:</p>
            <ul>
                {messages.map((msg) => (
                    <li key={msg}>{msg}</li>
                ))}
            </ul>
        </div>
    );
};
